module.exports = __webpack_public_path__ + "static/media/Rosalina.eb7ed2cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Rosalina.png
// module id = 38
// module chunks = 0